import { createContext } from "react";
import type { PLACubeViewSettings } from "./PLACubeTimeView";

export const PLACubeViewContext = createContext<PLACubeViewSettings>({});
